module.exports = __webpack_public_path__ + "static/media/empty-search.f1cc81d6.png";